module.exports = __webpack_public_path__ + "static/media/no-photo-details.261b5c41.png";